import React from "react";
import { SlArrowRight } from "react-icons/sl";
import { depCoins } from "../../../constants/constants";
import { BsArrowLeft } from "react-icons/bs";

const SelectCoin = ({
  setOpenDeposit,
  setDepositNetworks,
  setOpenDepositNetwork,
  setDepositCoinName,
}: any) => {
  return (
    <div className="fixed inset-0 overflow-auto pb-16 flex font-manrope justify-start items-start pt-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white h-[600px] overflow-auto  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenDeposit(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Deposit
          </h4>
        </div>
        <h4 className="text-gray-900 dark:text-gray-100 text-[16px] mt-4">
          Select coin to receive
        </h4>
        <div className="w-full mt-8">
          {depCoins.map((coin: any, index: any) => (
            <div
              key={index}
              onClick={() => {
                setDepositCoinName(coin.abbr);
                setDepositNetworks(coin.networks);
                setOpenDeposit(false);
                setOpenDepositNetwork(true);
              }}
              className="w-full border border-gray-200 dark:border-gray-600 p-4 rounded-xl cursor-pointer flex justify-between mt-4 items-center"
            >
              <div className="flex  items-center gap-3">
                <div className="flex justify-center items-center  w-[24px] h-[24px] rounded-full">
                  <img
                    src={coin.logo}
                    className="w-full h-full bg-cover"
                    alt=""
                  />
                </div>
                <div>
                  <h4 className="dark:text-gray-300 text-gray-900 font-medium text-[15px]">
                    {coin.abbr}
                  </h4>
                  <h4 className="dark:text-gray-400 text-gray-500 font-medium text-[13px]">
                    {coin.name}
                  </h4>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <SlArrowRight className="text-gray-600 dark:text-white text-[15px]" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectCoin;
